import { render, staticRenderFns } from "./CircularProgressBar.vue?vue&type=template&id=566c0a2f&scoped=true"
import script from "./CircularProgressBar.vue?vue&type=script&lang=js"
export * from "./CircularProgressBar.vue?vue&type=script&lang=js"
import style0 from "./CircularProgressBar.vue?vue&type=style&index=0&id=566c0a2f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c0a2f",
  null
  
)

export default component.exports